enum Status {
  IDLE = 'idle',
  LOADING = 'loading',
  LOADED = 'loaded',
  ERROR = 'error',
  PAYING = 'paying',
  PAYED = 'payed',
}

export default Status;
